<template>
  <div class="copy-offers-section">
    <div :class="['copy-offers-section__title pa-0 pb-3 h2-headline', title_class]">
      {{ title }}
    </div>
    <div class="copy-offers-section__text pa-0 ma-0 h6-text">
      {{ text }}
    </div>
    <div class="width-50">
      <sSelect
        class="copy-offers-section__offers mt-3 width-100"
        data-qa="copy_offers"
        :disabled="disabled"
        filterable
        :value.sync="copy_offers_value">
        <sOption
          v-for="item in bids_select_types"
          :key="`copy-offers-${item.value}`"
          :data-qa="`copy-offers-${item.value}`"
          :label="item.text"
          :value="item.value"/>
      </sSelect>
      <sAlert
        v-if="block_copy && copy_offers_value === 'SELECTED'"
        class="mt-2"
        data-qa="copyAlertBlocked"
        small
        type="warning">
        {{ not_possible_message }}
        <div slot="desc">
          {{ $t('Tenders.CriteriaInAdjustedPriceCalculation') }}
        </div>
      </sAlert>
      <template v-else>
        <sSelect
          v-if="copy_offers_value != 'NONE'"
          class="copy-offers-section__offers-files mt-3 width-100"
          data-qa="copy_offers_files"
          :disabled="disabled || attachments_required"
          filterable
          :value.sync="copy_offers_files_value">
          <sOption
            v-for="item in offers_attachments"
            :key="`offers-files-${item.value}`"
            :data-qa="`offers-files-${item.value}`"
            :label="item.text"
            :value="item.value"/>
        </sSelect>
      </template>
    </div>
  </div>
</template>
<script>
/**
Общий блок для модалок копирования тендера и создания нового етапа
*/
export default {
  name: 'copyOffersSection',
  computed: {
    copy_offers_value: {
      get() {
        return this.copy_offers
      },
      set(value) {
        this.$emit('update:copy_offers', value)
      }
    },
    copy_offers_files_value: {
      get() {
        return this.attachments_required ? true : this.copy_offers_files
      },
      set(value) {
        this.$emit('update:copy_offers_files', this.attachments_required ? true : value)
      }
    },
    bids_select_types() {
      return [
        {text: this.$t('Tenders.DoNotCopyOffers'), value: 'NONE' },
        {text: this.$t('Tenders.CopyAllOffers'), value: 'ALL' },
        {text: this.$t('Tenders.CopySelectedOffers'), value: 'SELECTED' },
      ]
    },
    offers_attachments() {
      return [
        {text: this.$t('Tenders.WithAttachments'), value: true },
        {text: this.$t('Tenders.DoNotCopyAttachments'), value: false },
      ]
    }
  },
  props: {
    title: String,
    text: String,
    title_class: [String, Object, Array],
    disabled: Boolean,
    block_copy: Boolean,
    not_possible_message: String,
    copy_offers: String,
    copy_offers_files: Boolean,
    attachments_required: Boolean,
  },
}
</script>
